import { render, staticRenderFns } from "./DiscreteEnvirodataDetails.vue?vue&type=template&id=f677a59a"
import script from "./DiscreteEnvirodataDetails.vue?vue&type=script&lang=js"
export * from "./DiscreteEnvirodataDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports